export enum Api {
    // user api
    login = 'auth/login',
    notifications = 'notifications',
    notificationsClean = 'notifications/clean',
    notificationsRead = 'notifications/read',
    logout = 'auth/logout',
    registration = 'auth/register',
    user = 'auth/me',
    restore = 'auth/forgot-password',
    changePassword = 'users/{id}/password',
    resetPassword = 'auth/password/reset',
    userId = 'users/{id}',
    // test api
    tests = 'tests',
    testsList = 'test-list',
    test = 'tests/{id}',
    testsFileXls = 'parse/test/excel',
    testsFileWord = 'parse/test/txt',
    disciplines = 'disciplines',
    universities = 'universities',
    departments = 'departments',
    appointTest = 'assignment-tests',
    appointTestFile = 'parse/assignment-test',
    appointTestRetake = 'assignment-tests/retake',
    shareTest = 'share/test',
    shareTestAccept = 'share/test/apply',
    shareTestAsigTestToUSer = 'share/assignment-test',
    // groups api
    groups = 'groups',
    // students api
    stud = 'student/{id}',
    studTestReport = 'student/report/{id}',
    studTests = 'student/tests',
    studInvite = 'student/invite',
    studInviteXls = 'parse/student/invite/{group_id}',
    studTest = 'student/tests/{id}/start',
    studTestFinish = 'student/tests/{id}/finish',
    studSearch = 'search/students',
    addAnswer = 'student/tests/{id}/testing',

}
